module.exports = __webpack_public_path__ + "static/media/home-carousel7.f3627766.webp";